module.exports = __webpack_public_path__ + "static/media/image_43.7a330cb2.png";